/* eslint-disable @typescript-eslint/no-use-before-define */
import { createAction } from '@reduxjs/toolkit'
import { all, call, put, takeLatest } from 'redux-saga/effects'
import { DesignerSkill } from 'src/common/common.interface'
import { getAllDesignerSkills } from 'src/api/products'
import { designerSkillAction } from './designerSkill.slice'

export function* getAllDesignerSkillsSaga() {
  try {
    const res: DesignerSkill[] = yield call(getAllDesignerSkills)
    yield put(designerSkillAction.setDesignerSkillsData(res))
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('error getAllDesignerSkills', error)
  } finally {
    yield put(designerSkillAction.setIsLoadingGetDesignerSkills(false))
  }
}

export const designerSkillActionSaga = {
  getAllDesignerSkills: createAction('designerSkillActionSaga/getAllDesignerSkills')
}

export default [
  function* fetchWatcher() {
    yield all([takeLatest(designerSkillActionSaga.getAllDesignerSkills, getAllDesignerSkillsSaga)])
  }
]
